// extracted by mini-css-extract-plugin
export default {"wrapper":"ChartBeneficiarias_wrapper__+iT2O"};